<template>


  <!-- Content -->
  <div class="admin-content">

    <div class="d-flex align-items-center justify-content-between flex-wrap mb-3">
      <!-- Left -->
      <div>
        <h5 class="mb-0 fw-semibold text-color">SMS Management</h5>
        <p class="mb-0 text-muted small">
          Manage contact with Customers
        </p>
      </div>
      <!-- Right -->
    </div>

    <div class="row">
      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-primary">Last 7 Day's</p>
              <p class="card-big-p text-color"> sms :
                <PriceFormat :Price="dataz.day7" />
              </p>
            </div>
          </div>


        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-danger">Last 30 Day's</p>
              <p class="card-big-p text-color">sms :
                <PriceFormat :Price="dataz.day30" />
              </p>
            </div>
          </div>


        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-green">Life Time SMS's</p>
              <p class="card-big-p text-color">sms :
                <PriceFormat :Price="dataz.sms_lifetime" />
              </p>
            </div>
          </div>


        </div>
      </div>

      <div class="col-md-3 col-sm-6 grid-col mob-mt">
        <div class="dashbord-card">
          <div class="d-flex justify-content-between">
            <div>
              <p class="card-p text-orange">Balance</p>
              <p class="card-big-p text-color">sms :
                <PriceFormat :Price="dataz.sms_balance" />
              </p>
            </div>
          </div>


        </div>
      </div>
    </div>

    <div class="card recent-orders-card mt-3 mb-5">
      <div class="card-header d-flex gap-3 align-items-center">
        <i class="fas fa-message text-primary"></i>
        <h6 class="mb-0 fw-semibold">
          <span class="text-color">Messaging Customer's</span>
        </h6>
      </div>
      <div class="card-body p-4">
        <div class="row align-items-stretch">
          <div class="col-md-6 col-sm-12 grid-col">
            <div class="form-group">
              <label class="text-color mb-2" for="message">Text Message <b>{{ charCount }}/{{ maxChars }}
                  <span v-if="charCount > 0">
                    SMS {{ smsCount }}
                  </span></b></label>
              <textarea :maxlength="maxChars" v-model="message" @input="handleInput" name=""
                placeholder="marketing or service messages..." class="form-control text-area" id="" rows="4"></textarea>
            </div>

            <div v-if="message_sending" class="mt-1">
              <div class="text-center">
                <div class="spinner-grow text-success" role="status"></div>
                <div class="spinner-grow text-danger" role="status"></div>
                <div class="spinner-grow text-warning" role="status"></div>
              </div>
            </div>

            <button @click="this.sendMessage()" class="btn-primary mt-3">
              <i class="fas fa-message me-2"></i>
              Send Message
            </button>
          </div>
          <div class="col-md-6 col-sm-12 grid-col">
            <div class="form-group">
              <label class="text-color mb-2" for="message">Phone Number's <i>comma (,) separated</i></label>
              <textarea v-model="this.phonesText" placeholder="0768448525,0686255811...." class="form-control text-area"
                id="" rows="4"></textarea>
            </div>
             <label class="text-color">Contacts : <b>{{ this.phones_counts }}</b></label>
          </div>
        </div>
      </div>
    </div>


    <div class="row align-items-stretch">
      <div class="col-md-12 col-sm-12 grid-col">

        <div class="product-filter-bar d-flex justify-content-between align-items-center flex-wrap gap-3 mob-mt">

          <!-- Left: Search -->
          <div class="filter-search d-flex">
            <input type="text" v-model="this.search_sms" class="filter-search-input" placeholder="Search order..." />
            <button @click="this.getSMSFilter()" class="filter-search-btn">
              <i class="fas fa-search"></i>
            </button>
          </div>

          <div v-if="searching" class="mt-1">
            <div class="text-center">
              <div class="spinner-grow text-success" role="status"></div>
              <div class="spinner-grow text-danger" role="status"></div>
              <div class="spinner-grow text-warning" role="status"></div>
            </div>
          </div>

          <!-- Right: Filters -->
          <div class="filter-actions d-flex align-items-center gap-2 mob-grid">
            <input type="date" v-model="this.sdate" class="filter-date-input" />
            <input type="date" v-model="this.edate" class="filter-date-input" />
            <button @click="this.getSMSFilter()" class="btn-primary">
              <i class="fas fa-filter me-1"></i>
              Filter
            </button>
          </div>
        </div>

        <div class="card recent-orders-card mt-3">

          <!-- Card Header -->
          <div class="card-header d-flex justify-content-between align-items-center">
            <h6 class="mb-0 fw-semibold">
              <span class="text-color">Message's</span>
            </h6>

          </div>

          <!-- Card Body -->
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table orders-table mb-0">
                <thead class="">
                  <tr>

                    <th class="">No</th>
                    <th class="">MESSAGE</th>
                    <th class="">DST-(SMS)</th>
                    <th class="">SEND-BY</th>
                    <th class="">SENT-AT</th>

                    <th class="text-end td-wd-sm">ACTION</th>
                  </tr>
                </thead>
                <tbody>

                  <tr v-for="(message, index) in paginatedMessages" :key="message.id">

                    <td class="text-color text-bold text-md">
                      {{ index + 1 }}
                    </td>
                    <td class="text-color text-bold text-sm">
                      {{ this.smsFormat(message.message) }}
                    </td>
                    <td class="text-primary text-bold text-md">{{ message.destinations }} - ({{ message.messages }})</td>
                    <td class="text-muted text-sm">{{ message.fulname }}</td>
                    <td class="text-color text-sm"><DateFormat :Date_="message.created_at"/></td>
                    <td class="text-end fw-semibold text-sm">
                       <div class="order-actions">
                              <button @click="addConfirmModel(message)" data-bs-toggle="modal" data-bs-target="#addConfirm" class="order-action-btn text-primary edit" title="Edit">
                                <i class="fas fa-eye"></i> Details
                              </button>
                             
                            </div>
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>

            <div class="pagination-wrapper">

              <button @click="currentPage--" :disabled="currentPage === 1">
                Prev
              </button>

              <button v-for="page in totalPages" :key="page" @click="currentPage = page"
                :class="{ active: currentPage === page }">
                {{ page }}
              </button>

              <button @click="currentPage++" :disabled="currentPage === totalPages">
                Next
              </button>

            </div>
          </div>

        </div>


      </div>

    </div>
        <div class="modal fade" id="addConfirm" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">

      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content custom-modal-style">

          <!-- HEADER -->
          <div class="modal-header custom-modal-header d-flex justify-content-between align-items-center">

            <h5 class="modal-title mb-0">Message Details</h5>
            <button type="button" class="btn-close ms-3 text-white fas fa-xmark" data-bs-dismiss="modal">
            </button>
          </div>

          <!-- BODY -->
           <div class="card-body custom-modal-body">
                            <p for="" class="text-uppercase text-secondary text-xs font-weight-bolder p-label">Message</p>
                            <p id="dmessage">{{ message_details.message }}</p>
                            <p for="" class="text-uppercase text-secondary text-xs font-weight-bolder p-label">Phone List</p>
                            <p class="text-xs" id="dphones">
                               {{ message_details.phone_list }} 
                            </p>
                             <div class="d-flex justify-content-between">
                              <p id="ddestination" class="text-primary">Phone List ({{ message_details.destinations }})</p>
                              <p id="dsms" class="text-primary">SMS {{ message_details.messages }}</p>
                            </div>
                            <div class="d-flex justify-content-between mt-2">
                            <p class="text-capitalize" id="dfulname">{{ message_details.fulname }}</p>
                           
                            </div>
                        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";


import PriceFormat from "@/components/PriceFormat.vue";
import DateFormat from "@/components/DateFormat.vue";

export default {
  components: {
    PriceFormat,
    DateFormat
  }, data() {
    return {
      add_btn: true,
      errors: "",
      data: [],
      tags: [],
      dataz: {},
      messages: [],
      og_messages: [],
      message_details:{},
      phonesText: "",
      message: "",
      maxChars: 459,
      currentPage: 1,
      perPage: 10,
      sdate: "",
      edate: "",
      message_sending: false,
      searching: false,
      search_sms: "",
      phones_counts:0,
      user: this.$attrs.user
    };
  },
  methods: {
    async smsData() {
       this.searching = true
      var response = await axios
        .get(this.$store.state.api_url + "/message-data")
        .catch((errors) => {
           this.searching = false
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 7000, dismissible: true });
        });

      if (response.data.success) {
         this.searching = false
        this.dataz = response.data.dataz;
        this.messages = response.data.dataz.messages;
        this.og_messages = response.data.dataz.messages;
      } else {
         this.searching = false
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });
      }
    },
    async sendMessage() {

      this.message_sending = true

      var phone_list = this.phonesText
      var message = this.message

      var response = await axios
        .post(this.$store.state.api_url + "/send-message", { phone_list, message })
        .catch((errors) => {
          this.message_sending = false
          var message_ = "Network or Server Errors";
          this.$toast.error(message_, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {

        this.phonesText = ""
        this.message = ""
        this.message_sending = false
        var message_ = response.data.message;
        this.$toast.success(message_, { duration: 5000, dismissible: true });
        this.smsData()
      } else {
        this.message_sending = false
        var message_ = response.data.message;
        this.$toast.error(message_, { duration: 5000, dismissible: true });

        //alert(response.data.message)
      }

    },
    async getSMSFilter() {

      this.searching = true

      var sdate = this.sdate
      var edate = this.edate
      var search = this.search_sms

      var response = await axios
        .post(this.$store.state.api_url + "/get-sms-filter", { sdate, edate, search })
        .catch((errors) => {
          this.searching = false
          var message = "Network or Server Errors";
          this.$toast.error(message, { duration: 5000, dismissible: true });
        });
      if (response.data.success) {
        this.searching = false
        this.search_sms = ""
        this.messages = response.data.messages;
        this.og_messages = response.data.messages;

      } else {
        this.searching = false
        var message = response.data.message;
        this.$toast.error(message, { duration: 5000, dismissible: true });

        //alert(response.data.message)
      }

    },
     smsFormat(context) {
      if(context == null || context == undefined || context == ""){
        return ""
      }else{
        if (context.length > 60) {
          return context.substring(0, 60) + "...";
        } else {
          return context;
        }
      }
    },
      addConfirmModel(message_details){
       this.message_details = message_details
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },


    handleInput(event) {
      let value = event.target.value;

      // Prevent typing beyond max
      if (value.length > this.maxChars) {
        value = value.substring(0, this.maxChars);
      }

      this.message = value;
    }

  },
  computed: {

    charCount() {
      return this.message.length;
    },

    smsCount() {
      if (this.charCount === 0) return 0;
      return Math.ceil(this.charCount / 153);
    },
    paginatedMessages() {
      const start = (this.currentPage - 1) * this.perPage
      const end = start + this.perPage

      return this.messages.slice(start, end)
    },

    totalPages() {
      return Math.ceil(this.messages.length / this.perPage)
    },

  },
  watch: {
    search_sms(value) {

      let term = value.toLowerCase().trim()

      if (!term) {
        this.messages = this.og_messages
        return
      }

      this.messages = this.og_messages.filter(message => {

        return (
          (message.fulname && message.fulname.toLowerCase().includes(term)) ||
          (message.phone_list && message.phone_list.toLowerCase().includes(term)) ||
          (message.phone && message.phone.toLowerCase().includes(term)) ||
          (message.message && message.message.toLowerCase().includes(term))

        )

      })

    },
     phonesText(value){
    var phones = value

    phones = phones.split(',')

    this.phones_counts = phones.length
  }
  },

  created() {
    this.$store.state.page_name = "Message's"
    this.smsData()
  },
};
</script>
